import LimitTooltip from './LimitTooltip';

export default LimitTooltip;
